import Cart from 'cart-store';

(function () {
  'use strict';
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function openCart() {
    var d = document.querySelector('.modal--cart, .popup--cart-notification');
    try {
      if (d && typeof d.open === 'function' && !d.shown) d.open();
      else if (d && d.interval) { d.interval.reset(); d.interval.start(); }
    } catch (e) { console.warn('[rs] open cart', e); }
  }
  function addItems(items) {
    var fail = T.add_fail || 'Kunde inte lägga i varukorgen';
    if (!Cart || typeof Cart.add !== 'function') return Promise.reject(new Error(fail));
    return Cart.add(items.map(function (i) { return { id: i.id, quantity: i.quantity }; }))
      .then(function (cart) {
        return Promise.resolve(Cart.resetVariantsBeingAdded && Cart.resetVariantsBeingAdded())
          .then(function () { openCart(); return cart; });
      })
      .catch(function (e) { console.warn('[rs] add', e); throw new Error((e && e.message) || fail); });
  }
  function bindAdd(root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rs-add],[data-rs-add-many]');
      if (!b) return;
      var ids = (b.getAttribute('data-rs-add') || b.getAttribute('data-rs-add-many') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      var msg = b.parentNode.querySelector('.sp-msg');
      b.disabled = true;
      if (msg) { msg.className = 'sp-msg'; msg.textContent = T.adding || 'Lägger till…'; }
      addItems(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }))
        .then(function () { if (msg) { msg.className = 'sp-msg sp-msg--ok'; msg.textContent = ids.length > 1 ? (T.kit_added || 'Paketet ligger i varukorgen') : (T.added || 'Tillagd i varukorgen'); } })
        .catch(function (err) { if (msg) { msg.className = 'sp-msg sp-msg--err'; msg.textContent = err.message; } })
        .then(function () { b.disabled = false; });
    });
  }
  function bindNav(root) {
    var nav = root.querySelector('[data-rs-nav]');
    if (!nav || !('IntersectionObserver' in window)) return;
    var links = [].slice.call(nav.querySelectorAll('a'));
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + en.target.id); });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (a) { var s = root.querySelector(a.getAttribute('href')); if (s) io.observe(s); });
  }
  function bindTopics(root) {
    var box = root.querySelector('[data-rs-topics]');
    if (!box) return;
    var input = box.querySelector('[data-rs-filter]'), empty = box.querySelector('[data-rs-empty]');
    var cats = box.querySelector('.rs-cats');
    input.addEventListener('input', function () {
      var q = norm(input.value).split(' ').filter(Boolean), any = false;
      box.querySelectorAll('[data-rs-topic]').forEach(function (t) {
        var tAny = false;
        t.querySelectorAll('[data-rs-group]').forEach(function (g) {
          var gAny = false;
          g.querySelectorAll('[data-rs-item]').forEach(function (li) {
            var txt = norm(li.textContent + ' ' + t.querySelector('h3').textContent + ' ' + g.querySelector('h4').textContent);
            var ok = q.every(function (w) { return txt.indexOf(w) > -1; });
            li.hidden = !ok; if (ok) gAny = true;
          });
          g.hidden = !gAny; if (gAny) tAny = true;
        });
        t.hidden = !tAny; if (tAny) any = true;
      });
      cats.hidden = q.length > 0;
      empty.hidden = any;
    });
  }
  function bindHub(root) {
    var q = root.querySelector('[data-rs-hub-q]'), res = root.querySelector('[data-rs-hub-results]');
    var grid = root.querySelector('[data-rs-hub-grid]'), chips = root.querySelector('[data-rs-hub-chips]');
    if (!q || !grid) return;
    var cards = [].slice.call(grid.querySelectorAll('.sp-mcard'));
    q.addEventListener('input', function () {
      var w = norm(q.value).split(' ').filter(Boolean);
      if (!w.length) { res.innerHTML = ''; return; }
      var hits = cards.filter(function (c) { var t = norm(c.getAttribute('data-name') + ' ' + c.getAttribute('data-fam') + ' ' + (c.getAttribute('data-flabel') || '')); return w.every(function (x) { return t.indexOf(x) > -1; }); }).slice(0, 8);
      res.innerHTML = hits.length ? hits.map(function (c) {
        var img = c.getAttribute('data-img');
        return '<li><a href="' + esc(c.getAttribute('href')) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '<span><strong>' + esc(c.getAttribute('data-name')) + '</strong><br><span class="sp-results__meta">' + esc(c.getAttribute('data-flabel') || c.getAttribute('data-fam')) + '</span></span></a></li>';
      }).join('') : '<li class="sp-results__empty">' + esc(T.hub_none || 'Ingen resurssida ännu.') + ' <a class="sp-link" href="/pages/reservdelar">' + esc(T.hub_none_link || 'Sök på reservdelssidan') + '</a></li>';
    });
    q.addEventListener('keydown', function (e) { if (e.key === 'Enter') { var a = res.querySelector('a'); if (a) { e.preventDefault(); location.href = a.href; } } });
    try {
      var pq = new URLSearchParams(location.search).get('q');
      if (pq) { q.value = pq; q.dispatchEvent(new Event('input')); setTimeout(function () { q.scrollIntoView({ block: 'center' }); q.focus(); }, 50); }
    } catch (e) {}
    if (chips) chips.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fam]'); if (!b) return;
      var f = b.getAttribute('data-fam');
      chips.querySelectorAll('[data-fam]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      cards.forEach(function (c) { c.hidden = !!f && c.getAttribute('data-fam') !== f; });
    });
  }
  function i18n(root){ try { return JSON.parse(root.getAttribute('data-rs-i18n')||'{}'); } catch(e){ return {}; } }
  var T = {};
  function init() {
    document.querySelectorAll('[data-rs]').forEach(function (root) { T = Object.assign(T, i18n(root)); bindAdd(root); bindNav(root); bindTopics(root); bindHub(root); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
